<template>
<div class="chapter">
<div class="inner_page">
<p class="chap_title"><span><a id="page_ix">AUTHOR’S NOTE</a></span></p><a id="page_ix">
<p class="normal">General Puller’s story seems to me one of the great narratives of our military history, as well as one of the most instructive. Surely no modern American general, even in retirement, has been so candid in his criticism of our military posture, policy, aims and equipment.</p>
<p class="indent">This book is as much a memoir as a biography, for it rests largely on a long series of interviews with General Puller and a lengthy study of his official record—buttressed by recollections of hundreds of others who have known him from childhood to the end of his military career, most of whom were interviewed by me.</p>
<p class="indent">General Puller’s prodigious memory is often relied upon, and in matters large and small his point of view is taken; controversial points are not examined from every side, and thus this does not pretend to be an objective history of the many campaigns in which he fought.</p>
<p class="indent">Marine Corps Headquarters made this task easier by providing access to the Puller files—probably the most voluminous in the Corps records—and to other official papers and photographs. Mrs. John W. Thomason, of Huntsville, Texas, kindly granted permission to use a letter by her late husband.</p>
<p class="indent">The book was proposed by Charles R. Sanders, Jr., of Raleigh, N.C., a veteran of the Korean War, to whom I am deeply grateful. I also owe special debts of gratitude to the Puller family, including Miss Pattie Leigh Puller of Richmond, Va., and also to Generals J. P. Berkeley and E. W. Snedeker of the Marine Corps, to Dr. Edward L. Smith of Twentynine Palms, Calif., to Sgt. Orville Jones of the 3rd Marine Division, Okinawa, and to Gerald White, Geneva, N.Y.</p>
<p class="indent">In addition to those listed in the Acknowledgments, I must express my appreciation to my editor, John A. S. Cushman, to Carlisle H. Humelsine, Donald J. Gonzales, Mrs. Virginia Roseberg and Miss Roberta Smith of Colonial Williamsburg in Virginia, and to my wife and children.</p>
<p class="right1-1"><span>Burke Davis</span></p>
<p class="right1-2"><span>Coke-Garrett House</span></p>
<p class="right1-3"><span>Williamsburg, Va.</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Authornote.vue?2976bfe4